import { print } from 'graphql';
import { gql } from 'graphql-tag';

import { getDateModified } from '../../utilities/utilityFunctions';
import { defaultDoc, getValueFromLocalStorage } from '../share/defaultDoc';
import type {
  SignAndStampFile,
  SignAndStampFileAdditionalFields,
  SignAndStampFileDocument,
} from './signAndStamp.types';

export const signAndStampFilePullQueryBuilder = (document: SignAndStampFile) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }

  const query = print(gql`
    query signAndStampFilesFeed(
      $siteId: Int!
      $disciplineId: Int!
      $lastModified: DateTime!
      $isLeadInspector: Boolean!
    ) {
      signAndStampFilesFeed(
        siteId: $siteId
        disciplineId: $disciplineId
        lastModified: $lastModified
        isLeadInspector: $isLeadInspector
      ) {
        fileId
        inspectionId
        fileUUID
        fileCategory
        drawingType
        isImageFile
        pcsId
        sizeMb
        originalPath
        extension
        name
        originalFileName
        allowSpaccess
        legacyId
        fkAssetInspectionTask
        siteId
        disciplineId
        fileDescription
        showOnReport
        isDelete
        isSaveForFuture
        userId
        dateCreated
        dateModified
        leadInspectorName
        leadInspectorTitle
        leadDesignation
        leadCompanyName
        fieldInspectorName
        fieldInspectorTitle
        fieldDesignation
        fieldCompanyName
      }
    }
  `);
  return {
    query,
    variables: {
      siteId: JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
      disciplineId: JSON.parse(getValueFromLocalStorage('selectedDiscipline'))
        ?.selectedDisciplineId,
      lastModified: getDateModified(
        doc?.dateModified,
        doc?.dateCreated,
        doc.siteId,
        doc.disciplineId,
        JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
        JSON.parse(getValueFromLocalStorage('selectedDiscipline'))?.selectedDisciplineId,
      ),
      isLeadInspector: getValueFromLocalStorage('isLeadInspector') === 'True',
    },
  };
};

export const signAndStampFilePushQueryBuilder = (doc: SignAndStampFile[]) => {
  const document = doc[0];
  const query = print(gql`
    mutation userSignAndStampFileInfo(
      $MobileUserSignAndStampInfoInput: MobileUserSignAndStampInfoInput
    ) {
      userSignAndStampFileInfo(userFileRequest: $MobileUserSignAndStampInfoInput) {
        fileId
        uUID
        inspectionId
        result
      }
    }
  `);

  const variables = {
    MobileUserSignAndStampInfoInput: document,
  };

  return {
    query,
    variables,
  };
};

export const SIGN_STAMP_BLACK_LISTED_KEYS = [
  '_attachments',
  '_rev',
  '_deleted',
  'dateCreated',
  'dateModified',
  '_meta',
  'isDeleted',
];

export const signAndStampFilePushModifier = (doc: SignAndStampFileDocument) => {
  const obj: SignAndStampFileDocument & SignAndStampFileAdditionalFields = {
    ...doc,
    isBulkOperation: false,
    isLiStamp: doc?.inspectionId?.length && doc?.fkAssetInspectionTask === 0 ? true : false,
  };
  SIGN_STAMP_BLACK_LISTED_KEYS.forEach(property => {
    obj[property as keyof SignAndStampFileAdditionalFields] = undefined;
  });
  return obj;
};
